// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__QqOOm","container__description":"styles_container__description__U5sdW","skeleton-animation":"styles_skeleton-animation__kgEi9"};